import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useOrganization } from "@/contexts/OrganizationContext";
import { useOrgCapabilities } from "@/features/settings/useOrgCapabilities";

/**
 * Restricts organization-management routes to owners and admins.
 *
 * Authentication is handled by the surrounding ProtectedRoute. This guard
 * waits for the active membership before evaluating its role so a permitted
 * user is not redirected while organization context is hydrating.
 */
export function OrgAdminRoute({ children }: { children: ReactNode }) {
  const { isLoading } = useOrganization();
  const { isAdmin } = useOrgCapabilities();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-500">Loading...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
